import moment from 'moment-timezone';
import { defaultCity, defaultPaymentMethod } from "../../utils";
import {
  SELECT_PRODUCT,
  SELECT_PRODUCT_DEFAULT,
  SELECT_CITY,
  SELECT_CITY_DEFAULT,
  SELECT_DATE,
  SELECT_DATE_DEFAULT,
  SELECT_GUEST_AMOUNT,
  SELECT_GUEST_AMOUNT_DEFAULT,
  SELECT_SORT_TYPE,
  SELECT_SORT_TYPE_DEFAULT,
  SELECT_DISTANCE,
  SELECT_DISTANCE_DEFAULT,
  SELECT_PRICE,
  SELECT_PRICE_DEFAULT,
  SELECT_EXPERIENCE,
  SELECT_EXPERIENCE_DEFAULT,
  REHYDRATE_STORE,
  UPDATE_SUGGESTIONS,
  SELECT_PAYMENT_METHOD,
  LOGOUT_SUCCESS,
} from '../types';

export const initialState = {
  payingWith: defaultPaymentMethod,
  product: '',
  city: defaultCity,
  suggestions: [],
  date: moment().format('YYYY-MM-DD'),
  guests: 2,
  experience: '',
  distance: {
    distanceHi: 0,
    distanceLo: 0,
  },
  price: {
    priceHi: 0,
    priceLo: 0,
  },
  sortType: 3,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case REHYDRATE_STORE: {
      return {
        ...state,
        ...action.payload,
      };
    }
    case LOGOUT_SUCCESS: {
      return {
        ...state,
        payingWith: defaultPaymentMethod,
      }
    }
    case SELECT_PAYMENT_METHOD:
      return {
        ...state,
        payingWith: action.payload,
      };
    case UPDATE_SUGGESTIONS: {
      return {
        ...state,
        suggestions: action.payload,
      };
    }
    case SELECT_PRODUCT:
      return {
        ...state,
        product: action.payload,
      };
    case SELECT_CITY:
      return {
        ...state,
        city: action.payload,
      };
    case SELECT_DATE:
      return {
        ...state,
        date: action.payload,
      };
    case SELECT_GUEST_AMOUNT:
      return {
        ...state,
        guests: action.payload,
      };
    case SELECT_SORT_TYPE:
      return {
        ...state,
        sortType: action.payload,
      };
    case SELECT_DISTANCE:
      return {
        ...state,
        distance: action.payload,
      };
    case SELECT_PRICE:
      return {
        ...state,
        price: action.payload,
      };
    case SELECT_EXPERIENCE:
      return {
        ...state,
        experience: action.payload,
      };
    case SELECT_PRODUCT_DEFAULT:
      return {
        ...state,
        product: '',
      };
    case SELECT_CITY_DEFAULT:
      return {
        ...state,
        suggestions: [],
        city: initialState.city,
      };
    case SELECT_DATE_DEFAULT:
      return {
        ...state,
        date: initialState.date,
      };
    case SELECT_GUEST_AMOUNT_DEFAULT:
      return {
        ...state,
        guests: initialState.guests,
      };
    case SELECT_SORT_TYPE_DEFAULT:
      return {
        ...state,
        sortType: initialState.sortType,
      };
    case SELECT_DISTANCE_DEFAULT:
      return {
        ...state,
        distance: initialState.distance,
      };
    case SELECT_PRICE_DEFAULT:
      return {
        ...state,
        price: initialState.price,
      };
    case SELECT_EXPERIENCE_DEFAULT:
      return {
        ...state,
        experience: initialState.experience,
      };
    default:
      return state;
  }
};
